import { DASHBOARD_URL } from 'constants/app';
import { useSession } from 'hooks/useSession';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router';
import { fetchWrapper } from 'utils/apiFetch';

const dashboardStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&family=JetBrains+Mono:wght@500;700&display=swap');

  .rd-root {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #eef2ff;
    min-height: 100vh;
  }

  .rd-banner {
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    background: linear-gradient(120deg, #0f172a 0%, #1e3a8a 45%, #312e81 100%);
    padding: 32px 32px 28px;
    margin-bottom: 4px;
    box-shadow: 0 8px 32px rgba(15,23,42,0.25);
  }
  .rd-banner::before {
    content: '';
    position: absolute;
    top: -60px; right: -60px;
    width: 260px; height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(99,102,241,0.35) 0%, transparent 70%);
    pointer-events: none;
  }
  .rd-banner::after {
    content: '';
    position: absolute;
    bottom: -80px; left: 20%;
    width: 320px; height: 200px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(59,130,246,0.2) 0%, transparent 70%);
    pointer-events: none;
  }
  .rd-banner-dots {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px);
    background-size: 28px 28px;
    pointer-events: none;
  }
  .rd-banner-greeting { font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.14em; color: rgba(165,180,252,0.85); margin-bottom: 6px; }
  .rd-banner-name { font-size: 1.75rem; font-weight: 900; color: #fff; margin-bottom: 6px; line-height: 1.15; }
  .rd-banner-sub { font-size: 0.82rem; color: rgba(255,255,255,0.5); margin: 0; font-weight: 500; }
  .rd-banner-badge { display: inline-flex; align-items: center; gap: 6px; background: rgba(74,222,128,0.15); border: 1px solid rgba(74,222,128,0.35); border-radius: 30px; padding: 5px 14px; font-size: 0.72rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #4ade80; margin-top: 16px; }
  .rd-banner-stat { background: rgba(255,255,255,0.07); border: 1px solid rgba(255,255,255,0.1); border-radius: 14px; padding: 14px 20px; text-align: center; backdrop-filter: blur(6px); }
  .rd-banner-stat-val { font-family: 'JetBrains Mono', monospace; font-size: 1.25rem; font-weight: 700; color: #fff; display: block; line-height: 1; margin-bottom: 4px; }
  .rd-banner-stat-lbl { font-size: 0.68rem; font-weight: 600; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.07em; }
  .rd-glow-dot { width: 8px; height: 8px; border-radius: 50%; background: #4ade80; box-shadow: 0 0 0 3px rgba(74,222,128,0.3); animation: rd-pulse 2s infinite; display: inline-block; }
  @keyframes rd-pulse {
    0%,100% { box-shadow: 0 0 0 3px rgba(74,222,128,0.3); }
    50%      { box-shadow: 0 0 0 6px rgba(74,222,128,0.08); }
  }

  .rd-stat-card { border: none !important; border-radius: 20px !important; overflow: hidden; position: relative; transition: transform 0.22s ease, box-shadow 0.22s ease; box-shadow: 0 4px 20px rgba(0,0,0,0.10) !important; height: 100%; }
  .rd-stat-card:hover { transform: translateY(-5px); box-shadow: 0 16px 40px rgba(0,0,0,0.16) !important; }
  .rd-stat-card .card-body { padding: 24px !important; }
  .rd-stat-card::after { content: ''; position: absolute; bottom: -30px; right: -30px; width: 110px; height: 110px; border-radius: 50%; background: rgba(255,255,255,0.07); pointer-events: none; }
  .rd-stat-card-wallet  { background: linear-gradient(135deg,#0f172a,#1e3a8a) !important; }
  .rd-stat-card-credit  { background: linear-gradient(135deg,#164e63,#0891b2) !important; }
  .rd-stat-card-profile { background: linear-gradient(135deg,#14532d,#16a34a) !important; }
  .rd-stat-card-time    { background: linear-gradient(135deg,#581c87,#9333ea) !important; }
  .rd-stat-icon-wrap { width: 44px; height: 44px; border-radius: 12px; background: rgba(255,255,255,0.12); display: flex; align-items: center; justify-content: center; font-size: 1.3rem; margin-bottom: 16px; border: 1px solid rgba(255,255,255,0.1); }
  .rd-stat-label { font-size: 0.7rem !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.1em; color: rgba(255,255,255,0.55) !important; margin-bottom: 6px !important; }
  .rd-stat-amount { font-family: 'JetBrains Mono', monospace !important; font-size: 1.65rem !important; font-weight: 700 !important; color: #fff !important; margin: 0 0 6px !important; letter-spacing: -0.5px; }
  .rd-stat-sub { font-size: 0.7rem; color: rgba(255,255,255,0.38); margin: 0; font-weight: 500; }
  .rd-kyc-badge { display: inline-flex; align-items: center; gap: 6px; background: rgba(74,222,128,0.15); border: 1px solid rgba(74,222,128,0.3); border-radius: 20px; padding: 3px 10px; font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #4ade80; margin-bottom: 10px; }

  .rd-section-wrap { margin-top: 32px; }
  .rd-section-header { display: flex; align-items: center; gap: 0; margin-bottom: 16px; position: relative; }
  .rd-section-pill { display: inline-flex; align-items: center; gap: 10px; background: linear-gradient(135deg, #1e3a8a, #4f46e5); border-radius: 12px 0 0 12px; padding: 10px 20px 10px 16px; box-shadow: 0 4px 14px rgba(79,70,229,0.35); }
  .rd-section-emoji { font-size: 1.2rem; line-height: 1; filter: drop-shadow(0 1px 2px rgba(0,0,0,0.2)); }
  .rd-section-title { font-size: 0.82rem !important; font-weight: 800 !important; color: #fff !important; text-transform: uppercase; letter-spacing: 0.1em; margin: 0 !important; }
  .rd-section-tail { flex: 1; height: 42px; background: linear-gradient(90deg, rgba(79,70,229,0.12), transparent); border-radius: 0 12px 12px 0; display: flex; align-items: center; padding-left: 14px; gap: 10px; }
  .rd-section-count { font-size: 0.68rem; font-weight: 700; background: #e0e7ff; color: #4f46e5; border-radius: 20px; padding: 2px 10px; white-space: nowrap; }
  .rd-section-line { flex: 1; height: 1px; background: linear-gradient(90deg, #c7d2fe, transparent); }

  .rd-service-card { border: none !important; border-radius: 16px !important; background: #fff !important; box-shadow: 0 2px 10px rgba(0,0,0,0.06) !important; cursor: pointer; transition: transform 0.18s ease, box-shadow 0.18s ease; position: relative; overflow: hidden; height: 100%; }
  .rd-service-card::after { content: ''; position: absolute; inset: 0; background: linear-gradient(135deg, rgba(79,70,229,0.04), transparent 60%); opacity: 0; transition: opacity 0.2s; }
  .rd-service-card:hover { transform: translateY(-4px) scale(1.015); box-shadow: 0 16px 36px rgba(0,0,0,0.12) !important; }
  .rd-service-card:hover::after { opacity: 1; }
  .rd-service-card:active { transform: scale(0.97); }
  .rd-service-card .card-body { padding: 14px 16px !important; }
  .rd-service-img { width: 46px; height: 46px; border-radius: 13px; background-size: cover; background-position: center; box-shadow: 0 3px 10px rgba(0,0,0,0.14); flex-shrink: 0; border: 2px solid rgba(255,255,255,0.8); }
  .rd-service-name { font-size: 0.8rem !important; font-weight: 700 !important; color: #1e293b !important; margin-bottom: 2px !important; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; line-height: 1.3; }
  .rd-service-cat { font-size: 0.65rem !important; color: #94a3b8 !important; text-transform: capitalize; font-weight: 600; margin: 0 !important; }
  .rd-active-dot { position: absolute; top: 10px; right: 10px; width: 7px; height: 7px; border-radius: 50%; background: #22c55e; box-shadow: 0 0 0 2px rgba(34,197,94,0.25); }
  .rd-service-arrow { position: absolute; bottom: 10px; right: 12px; font-size: 0.7rem; color: #c7d2fe; transition: color 0.18s, transform 0.18s; }
  .rd-service-card:hover .rd-service-arrow { color: #6366f1; transform: translateX(3px); }

  .rd-fadein { animation: rd-fade 0.45s ease both; }
  @keyframes rd-fade {
    from { opacity:0; transform:translateY(14px); }
    to   { opacity:1; transform:translateY(0); }
  }
`;

// ── Helpers ───────────────────────────────────────────────────────────────────
const fmtAmt = (n) => '₹' + (parseFloat(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

function RetailerDashboard() {
  const [data, setData]           = useState(null);
  const [loading, setLoading]     = useState(true);
  const [error, setError]         = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const { userid } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role && role.toLowerCase() !== 'retailer') navigate(DASHBOARD_URL[role]);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchWrapper(`https://pro.mokshiq.in/get_user_profile?user=${userid}`);
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const groupServicesByCategory = (services) => {
    if (!services) return {};
    return services.reduce((acc, service) => {
      const cat = service.category || 'other';
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(service);
      return acc;
    }, {});
  };

  const categoryLabels = {
    banking:           { label: 'Banking',       emoji: '🏦' },
    recharge:          { label: 'Recharge',      emoji: '📱' },
    bbps:              { label: 'BBPS Services', emoji: '💡' },
    aeps:              { label: 'AEPS',          emoji: '🏧' },
    wallet_settlement: { label: 'Wallet',        emoji: '💰' },
    report:            { label: 'Reports',       emoji: '📊' },
    user:              { label: 'Account',       emoji: '👤' },
    referal:           { label: 'Referral',      emoji: '🎁' },
  };

  const getGreeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Good Morning';
    if (h < 17) return 'Good Afternoon';
    return 'Good Evening';
  };

  if (loading) {
    return (
      <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(238,242,255,0.9)', zIndex: 3000, backdropFilter: 'blur(6px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading…</span>
          </div>
          <p style={{ color: '#6366f1', fontWeight: 700, fontSize: '0.78rem', letterSpacing: '0.1em', margin: 0 }}>LOADING DASHBOARD…</p>
        </div>
      </div>
    );
  }

  if (error || !data) {
    return <div style={{ padding: 40, textAlign: 'center', color: '#f85149' }}>⚠️ Failed to load dashboard: {error}</div>;
  }

  // ── API field mapping ──────────────────────────────────────────────────────
  // data.wallet_balance      → user_account.wallet_ammount  (main wallet)
  // data.nwallet_balance     → user_account.main_wallet     (commission/credit wallet — named oddly in API)
  // data.daily_sales.other_products.total_amount   → today's sales (non-wallet)
  // data.daily_sales.other_products.total_profit   → today's earning
  // data.daily_sales.wallet_settlement.total_amount→ today's wallet settlement amount
  // data.daily_sales.wallet_settlement.total_charge→ today's wallet settlement charge
  // data.monthly_sales.other_products.total_amount → monthly sales
  // data.monthly_sales.other_products.total_profit → monthly earning
  // data.main_service_list  → [{ name, photo, category, web_url }]
  // data.kyc                → kyc status string

  const dailyOther    = data.daily_sales?.other_products    || {};
  const dailyWallet   = data.daily_sales?.wallet_settlement || {};
  const monthlyOther  = data.monthly_sales?.other_products  || {};
  const monthlyWallet = data.monthly_sales?.wallet_settlement || {};

  return (
    <main className="rd-root">
      <style>{dashboardStyles}</style>
      <div className="container-fluid mt-3 pb-5 px-3">
        <div className="rd-fadein">

          {/* ── Banner ── */}
          <div className="rd-banner mb-4">
            <div className="rd-banner-dots"></div>
            <div className="row align-items-center g-3">
              <div className="col-md-6">
                <p className="rd-banner-greeting">👋 {getGreeting()}</p>
                <h2 className="rd-banner-name">{data.name}</h2>
                <p className="rd-banner-sub">+91 {data.mobile} &nbsp;·&nbsp; Retailer Dashboard</p>
                <div className="rd-banner-badge">
                  <span className="rd-glow-dot"></span>
                  KYC {data.kyc}
                </div>
              </div>
              <div className="col-md-6">
                <div className="row g-2">
                  {/* FIX: removed double ₹₹, using fmtAmt helper */}
                  <div className="col-6">
                    <div className="rd-banner-stat">
                      <span className="rd-banner-stat-val">{fmtAmt(monthlyOther.total_amount)}</span>
                      <span className="rd-banner-stat-lbl">Monthly Sales</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rd-banner-stat">
                      <span className="rd-banner-stat-val">{fmtAmt(monthlyOther.total_profit)}</span>
                      <span className="rd-banner-stat-lbl">Monthly Profit</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rd-banner-stat">
                      {/* FIX: was ₹₹ (double) — now single ₹ via fmtAmt */}
                      <span className="rd-banner-stat-val">{fmtAmt(dailyOther.total_profit)}</span>
                      <span className="rd-banner-stat-lbl">Today's Earning</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rd-banner-stat">
                      {/* FIX: was ₹₹ (double) — now single ₹ via fmtAmt */}
                      <span className="rd-banner-stat-val">{fmtAmt(dailyOther.total_amount)}</span>
                      <span className="rd-banner-stat-lbl">Today's Sales</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* ── Stat cards ── */}
          <div className="row g-3 mb-1">
            <div className="col-sm-6 col-md-3">
              <div className="card rd-stat-card rd-stat-card-wallet">
                <div className="card-body">
                  <div className="rd-stat-icon-wrap">💳</div>
                  <p className="rd-stat-label">Wallet Balance</p>
                  {/* FIX: was data?.wallet_balance?.toFixed(2) — crashes if null; use fmtAmt */}
                  <h2 className="rd-stat-amount">{fmtAmt(data?.wallet_balance)}</h2>
                  <p className="rd-stat-sub">Main wallet · Available</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-3">
              <div className="card rd-stat-card rd-stat-card-credit">
                <div className="card-body">
                  <div className="rd-stat-icon-wrap">🏧</div>
                  <p className="rd-stat-label">Credit Wallet</p>
                  {/* FIX: was data?.nwallet_balance?.toFixed(2) — crashes if null; use fmtAmt */}
                  <h2 className="rd-stat-amount">{fmtAmt(data?.nwallet_balance)}</h2>
                  <p className="rd-stat-sub">Available credit limit</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-3">
              <div className="card rd-stat-card rd-stat-card-profile">
                <div className="card-body">
                  <div className="rd-kyc-badge">
                    <span className="rd-glow-dot"></span>
                    {data.kyc}
                  </div>
                  <p className="rd-stat-label">Retailer</p>
                  <h2 className="rd-stat-amount" style={{ fontSize: '1.2rem' }}>{data.name}</h2>
                  <p className="rd-stat-sub">+91 {data.mobile}</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-3">
              <div className="card rd-stat-card rd-stat-card-time">
                <div className="card-body">
                  <div className="rd-stat-icon-wrap">🕐</div>
                  <p className="rd-stat-label">Current Time</p>
                  <h3 className="rd-stat-amount" style={{ fontSize: '1.3rem' }}>{currentTime.toLocaleTimeString()}</h3>
                  <p className="rd-stat-sub">
                    {currentTime.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ── Services by category ── */}
          {Object.entries(groupServicesByCategory(data?.main_service_list)).map(([category, services]) => {
            const meta = categoryLabels[category] || {
              label: category.charAt(0).toUpperCase() + category.slice(1),
              emoji: '📂',
            };
            return (
              <div key={category} className="rd-section-wrap">
                <div className="rd-section-header">
                  <div className="rd-section-pill">
                    <span className="rd-section-emoji">{meta.emoji}</span>
                    <h5 className="rd-section-title">{meta.label}</h5>
                  </div>
                  <div className="rd-section-tail">
                    <span className="rd-section-count">{services.length} services</span>
                    <div className="rd-section-line"></div>
                  </div>
                </div>
                <div className="row g-3">
                  {services.map((service, index) => (
                    <div key={index} className="col-md-3 col-6" onClick={() => navigate(`/${service.web_url}`)}>
                      <div className="card rd-service-card">
                        <div className="card-body">
                          <div className="rd-active-dot"></div>
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="rd-service-img"
                              style={{ backgroundImage: `url(https://pro.mokshiq.in/media/${service.photo})` }}
                            />
                            <div style={{ overflow: 'hidden', flex: 1 }}>
                              <h6 className="rd-service-name">{service.name}</h6>
                              <p className="rd-service-cat">{service.category}</p>
                            </div>
                          </div>
                          <span className="rd-service-arrow">›</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}

        </div>
      </div>
    </main>
  );
}

export default RetailerDashboard;